var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCamera(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26.5,
    height: 22.928,
    viewBox: "0 0 26.5 22.928",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #7d7d7d;\n      }\n\n      .cls-2 {\n        fill: none;\n        stroke: #7d7d7d;\n        stroke-linecap: round;\n        stroke-linejoin: round;\n        stroke-miterlimit: 10;\n        stroke-width: 1.5px;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_11294",
    "data-name": "Group 11294",
    transform: "translate(0.699 0.75)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10606",
    "data-name": "Group 10606",
    transform: "translate(0.051 0)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1862",
    "data-name": "Ellipse 1862",
    className: "cls-1",
    cx: 2.34,
    cy: 2.34,
    r: 2.34,
    transform: "translate(10.142 6.056)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7226",
    "data-name": "Path 7226",
    className: "cls-2",
    d: "M363.172,2.926H356.4A2.179,2.179,0,0,1,354.2.762V-4.2h25V.762a2.22,2.22,0,0,1-2.241,2.2h-6.375",
    transform: "translate(-354.2 4.2)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7227",
    "data-name": "Path 7227",
    className: "cls-2",
    d: "M371.511,17.9h8.175a12.143,12.143,0,1,1-24.286,0h8.532",
    transform: "translate(-355.088 -8.651)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_1863",
    "data-name": "Ellipse 1863",
    className: "cls-2",
    cx: 1.607,
    cy: 1.612,
    rx: 1.607,
    ry: 1.612,
    transform: "translate(11.056 14.149)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_1864",
    "data-name": "Ellipse 1864",
    className: "cls-1",
    cx: 0.357,
    cy: 0.358,
    rx: 0.357,
    ry: 0.358,
    transform: "translate(12.305 15.403)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCamera);
export default __webpack_public_path__ + "static/media/camera.9ded9090242ace29031a1a1a013ab015.svg";
export { ForwardRef as ReactComponent };